import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Actions, ofActionCompleted } from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';
import { SsoLogin } from '@shared/store/auth/auth.actions';
import { LoginSuccess, LoginError } from '@shared/store/auth/auth.actions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslationService } from '@shared/services/translation.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'saf-sso-callback',
  template: '<p>Signing in…</p>',
  standalone: false,
})
export class SsoCallbackComponent implements OnInit {
  private destroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private actions$: Actions,
    private snackBar: MatSnackBar,
    private translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    const hash = window.location.hash?.substring(1);
    if (!hash) {
      this.store.dispatch(new Navigate(['/login']));
      return;
    }

    let payload: any;
    try {
      const base64 = hash.replace(/-/g, '+').replace(/_/g, '/');
      payload = JSON.parse(atob(base64));
    } catch {
      this.snackBar.open(this.translationService.translate('ssoLoginFailed'));
      this.store.dispatch(new Navigate(['/login']));
      return;
    }

    if (!payload?.success || !payload.jwt || !payload.refreshToken) {
      this.snackBar.open(
        this.translationService.translate(payload?.error || 'ssoLoginFailed')
      );
      this.store.dispatch(new Navigate(['/login']));
      return;
    }

    this.actions$.pipe(
      ofActionCompleted(LoginSuccess),
      takeUntil(this.destroy$),
    ).subscribe(() => {
      const redirect = sessionStorage.getItem('redirect');
      if (redirect) {
        sessionStorage.removeItem('redirect');
      }
      this.store.dispatch(new Navigate([redirect || '/']));
    });

    this.actions$.pipe(
      ofActionCompleted(LoginError),
      takeUntil(this.destroy$),
    ).subscribe(({ action }) => {
      this.snackBar.open(
        this.translationService.translate((action as LoginError).payload?.error || 'ssoLoginFailed')
      );
      this.store.dispatch(new Navigate(['/login']));
    });

    this.store.dispatch(new SsoLogin({ jwt: payload.jwt, refreshToken: payload.refreshToken }));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }
}
